import React, { useEffect, useState } from "react";
import { TableManger, TABLES } from "../../managers/TableManger";
import {
  DKLabel,
  DKCheckMark,
  DKButton,
  INPUT_TYPE,
  DKIcons,
} from "deskera-ui-library";
import UserManager from "../../managers/UserManager";
import i18next from "i18next";
import Utility from "../../utility/Utility";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";

interface IContextMenuProps {
  tableName: string;
  displayTableName: string;
  className?: string;
  onDelete?: () => void;
  onCancel?: () => void;
  onApply?: (data) => void;
  onEdit?: () => void;
  onCheckPrint?:()=>void;
  isCheckPrint?:boolean;
  isShowEdit?: boolean;
  isSelectOptionShow? :boolean;
  onRowSelectActionBtn?:any;
  selection?:any;
  isShowRevert? :boolean;
  onRevertClick?:(data)=>void;
  addMenuButton?:any;
  hideTableName? :any;
  SelectOptionColumnsShow?: any;
  module?: any;
}
const ContextMenu = (props: IContextMenuProps) => {
  let columnsToShow = TableManger.getTableColumns(props.tableName)?.filter(
    (column) =>
      (column.type === INPUT_TYPE.SELECT ||
        column.type === INPUT_TYPE.MULTI_SELECT) &&
      column.editable
  );
  let [count, setCount] = useState(0);
  let [columns, setColumns] = useState([]);
  let [opData, setOpData] = useState({});

  useEffect(() => {
    setColumns(JSON.parse(JSON.stringify(columnsToShow ? columnsToShow:[])));
  }, [count]);

  const onSelect = (column, data) => {
    let newOpData = opData;
    opData[column.id] = data;
    setOpData(newOpData);
    setCount((prevCount) => prevCount + 1);
  };

  const onApply = () => {
    if (props.onApply) props.onApply(opData);
  };
  const onRevertClick=()=>{
    if (props.onRevertClick) props.onRevertClick(props.selection);
  }
  const isShowForMultiple = (btn)=>{
    if(props.selection && props.selection.length>1 && btn.isShowForMultiple) {
      return true;
    } else if(props.selection && props.selection.length == 1) {
      let row = props.selection;
      if(btn.condition) {
        let keys = Object.keys(btn.condition);
        let isShow = false;
        keys.forEach(key=>{
          if(btn.condition[key] == row[0][key]) {
            isShow= true
          } else {
            isShow= false
          }
        })
        return isShow
      } else {
        return true;
      }
    } else {
      return false;
    }
  }
  const getManagerTitle=(btn)=>{
    let title = {
      text:'',
      value:false
    };
    if(btn.onSelectionTitle) {
      title.text = btn.onSelectionTitle.title1
    } else {
      title.text = btn.title
    }
    
    let ind = props.selection.findIndex(res=>res?.data?.role !="manager")
    if(ind == -1) {
      title = {
        text: btn.onSelectionTitle ? btn.onSelectionTitle.title2: btn.title,
        value:true
      }
    }
    return title;
  }
  const hasDeleteAccess = () => {
    if(props.module === MODULE.PAYRUN && props.tableName === TABLES.PAYROLL_PROCESS) {
      return PermissionUtils.hasAccess(MODULE.PAYRUN, ACTION.EDIT)
    } else {
      return PermissionUtils.hasAccess(props.module, ACTION.DELETE)
    }
  }
  return (
    <div className={`parent-width row pt-s ${props.tableName === TABLES.PEOPLE_SHIFTS || props.tableName === TABLES.PEOPLE_ASSIGN_MEMBERS ? "" : "mb-xs"}`} >
      {!Utility.isEmpty(props.displayTableName?.trim())&&<DKLabel text={props.displayTableName} className={`fw-m fs-m mr-l text-align-left white-space-no-wrap ${props.hideTableName?.hidden ? "d-none":""} `} />}
      {(props.hideTableName?.hidden &&!Utility.isEmpty(props.displayTableName?.trim()))&& <DKLabel text="" style={{width:`${props.hideTableName?.width}px `}} className={`fw-m fs-m mr-l text-align-left white-space-no-wrap  `} />}
      
      <div className={`row hide-scroll-bar ${(props.addMenuButton)? "ml-6":""}`} style={{ width: "auto", overflowX:'auto' }}>

        {(props.isSelectOptionShow && PermissionUtils.hasAccess(props.module, ACTION.EDIT))&&<span className="d-flex">

        {columns.map((column) => {
          if(props.SelectOptionColumnsShow) {
            if(props.SelectOptionColumnsShow.find(s=>s === column.id)) {
              switch (column.type) {
                case INPUT_TYPE.MULTI_SELECT:
                  return (
                    <MultiSelectList
                      {...column}
                      className={`mr-r`}
                      onSelect={(data) => onSelect(column, data)}
                    />
                  );
                case INPUT_TYPE.SELECT:
                  return (
                    <SelectList
                      {...column}
                      className={`mr-r`}
                      onSelect={(data) => onSelect(column, [data])}
                    />
                  );
              }
            }
          }
          
        })}
        </span>}
        {(props.isShowEdit && PermissionUtils.hasAccess(props.module, ACTION.EDIT)) && <DKButton
          title="Edit"
          icon={DKIcons.ic_edit}
          className="mr-r bg-white  border-m"
          onClick={() => (props.onEdit ? props.onEdit() : false)}
        />}
        {((!props.addMenuButton) && hasDeleteAccess() ) && <DKButton
          title="Delete"
          className="border-red mr-r bg-red text-white"
          onClick={() => (props.onDelete ? props.onDelete() : false)}
        />}
        {(Object.keys(opData).length > 0 && PermissionUtils.hasAccess(props.module, [ACTION.EDIT,ACTION.APPROVE,ACTION.SUBMIT])) && (
          <DKButton
            title="Apply"
            className="border-green mr-r bg-green text-white"
            onClick={() => onApply()}
          />
        )}
        {
          (props.isShowRevert && PermissionUtils.hasAccess(props.module, ACTION.SUBMIT)) && (
            <DKButton
                title="Revert"
                className="border-m mr-r bg-white"
                onClick={()=>onRevertClick()}
              />
          )
        }
        {
          props.addMenuButton && (
            props.addMenuButton?.map(btn=>{
              return (
                <>
                  {isMenuButtonVisible(btn,props) && <DKButton 
                  title={btn.onSelectionTitle ? (getManagerTitle(btn).text ):btn.title}
                  icon={btn.icon}
                  className={btn.className}
                  onClick={()=>btn.onClick(props.selection,getManagerTitle(btn).value )}
                  />}
                </>
              )
            })
          )
        }

        {props.isCheckPrint &&
            <DKButton
                icon={DKIcons.white.ic_download}
                title="Check Print"
                className="bg-app text-white mr-r"
                onClick={() => (props.onCheckPrint ? props.onCheckPrint() : false)}
            />
        }
        
        <DKButton
          icon={DKIcons.ic_close}
          className="border-m mr-r bg-white"
          onClick={() => (props.onCancel ? props.onCancel() : false)}
        />
        
      </div>
    </div>
  );
};
const isMenuButtonVisible=(btn,props)=>{
  let isConditionMatch = true;
  let btnVisible = !btn.hide
  if(btn.condition) {
    let ind = props.selection.findIndex(r=>{
      if(Array.isArray(r[btn.condition.columnCode])) {
        btnVisible = true
        return r[btn.condition.columnCode].find(val=>val != btn.condition.value)
      } else if(r[btn.condition.columnCode] != btn.condition.value) {
        return true
      }
    })
    if(ind != -1) {
      isConditionMatch = false
    }
    if(!Utility.isEmpty(btn.condition?.keyMatch)) {
      
      const isActionDisabled = props.selection?.findIndex(row=>( !Utility.isEmpty(row.data?.isActionDisabled) ));

      let hasApprovalStages = -1;
      let approverHasLevelAccess = -1;
      if(isActionDisabled !== -1) {
        isConditionMatch = false
      }
      if(isConditionMatch) {
        btnVisible = !btn.hide
        hasApprovalStages = props.selection?.findIndex(row=>( !Utility.isEmpty(row.data?.approvalStages) ));
        if(hasApprovalStages !== -1) {
          approverHasLevelAccess = props.selection?.findIndex(row=>!row.isMultilevelApproval);
          if(approverHasLevelAccess !== -1 ) {
            btnVisible = false;
          } else {
            btnVisible = true;
          }
        } else if(props.module === MODULE.EXPENSE_CLAIM && PermissionUtils.hasAccess(props.module, [ACTION.APPROVE,ACTION.REJECT])) {
          btnVisible = true;
        }
      }
    }
    if(btn.title ==  i18next.t("SUBMIT")) {
      let userId = UserManager.getUserDetails().id
      let userInd = props.selection.findIndex(r=>r.data.userId!= userId)
      if(userInd != -1) {
        isConditionMatch = false
      }
    }
  }
  let hasAccess = true;
  if(props.module) {
    hasAccess = PermissionUtils.hasAccess(props.module, [ACTION.EDIT, ACTION.APPROVE, ACTION.REJECT, ACTION.SUBMIT])
    if(props.module === MODULE.SHIFT_ASSIGNMENT) {
      hasAccess = PermissionUtils.hasAccess(props.module, [ACTION.EDIT, ACTION.APPROVE, ACTION.REJECT, ACTION.SUBMIT,ACTION.DELETE])
    }
  }
  
  return (btnVisible && isConditionMatch && hasAccess)
}
const SelectList = (props: any) => {
  const [showList, setShowList] = useState(false);
  const [options, setOptions] = useState(props.options);

  const onOptionSelect = (index) => {
    let newOptions = [...options].filter((item, i) => {
      item.selected = false;
      if (index === i) {
        item.selected = true;
        props.onSelect(item);
      }
      return item;
    });
    setOptions(newOptions);
    setShowList(false);
  };
  const getOptionList = () => {
    return (
      <div
        className="option-list-wrapper column bg-white p-s shadow-l"
        style={{
          position: "absolute",
          zIndex: 2,
        }}
      >
        {options.map((option, index) => {
          return (
            <div
              className="p-xs cursor-hand row"
              onClick={() => onOptionSelect(index)}
            >
              <DKLabel text={option.name} />
            </div>
          );
        })}
      </div>
    );
  };
  useEffect(() => {
    window.addEventListener("onContextMenuClick", onClick);
    window.addEventListener("click", onClick);
    return () => {
      window.removeEventListener("click", onClick);
      window.removeEventListener("onContextMenuClick", onClick);
    };
  });
  
  const onClick = (e) => {
    
    if (
      ( e.target?.parentElement?.parentElement?.id !== props.id) ) {
      if(showList) {
        setShowList(false);
      }
    }
  };
  const onButtonClick = (e) => {
    document.dispatchEvent(
      new CustomEvent("onContextMenuClick", { detail: { id: props.id } })
    );
    e.stopPropagation();
    setShowList(!showList);
  };

  return (
    <div
      className={`multi-select-list parent-width fw-m ${props.className}`}
      style={props.style}
      id={props.id}
    >
      <DKButton
      id={props.id}
        className={`border-m bg-white shadow-s ${
          options.find((i) => i.selected) ? "border-blue text-blue" : ""
        }`}
        icon={showList ? DKIcons.ic_arrow_up2 : DKIcons.ic_arrow_down2}
        isReverse={true}
        onClick={(e) => {onButtonClick(e);setShowList(!showList)}}
        title={
          options.find((i) => i.selected)
            ? options.find((i) => i.selected).name
            : props.name
        }
      />
      {showList && getOptionList()}
    </div>
  );
};
const MultiSelectList = (props: any) => {
  const [showList, setShowList] = useState(false);
  const [options, setOptions] = useState(props.options);

  const onOptionSelect = (index) => {
    let newOptions = [...options];
    newOptions[index]["selected"] = !newOptions[index]["selected"];
    setOptions(newOptions);
    props.onSelect(newOptions.filter((option) => option.selected));
  };

  useEffect(() => {
    window.addEventListener("onContextMenuClick", onClick);
    window.addEventListener("click", onClick);
    return () => {
      window.removeEventListener("click", onClick);
      window.removeEventListener("onContextMenuClick", onClick);
    };
  });
  
  const onClick = (e) => {
    console.log(e)
    if (
      ( e.target?.parentElement?.parentElement?.id !== props.id) 
    ) {
      if(showList) {
        setShowList(false);
      }
      
    }
  };
  const onButtonClick = (e) => {
    document.dispatchEvent(
      new CustomEvent("onContextMenuClick", { detail: { id: props.id } })
    );
    e.stopPropagation();
    setShowList(!showList);
  };

  const getOptionList = () => {
    return (
      <div
        className="option-list-wrapper column bg-white p-s shadow-l"
        style={{
          position: "absolute",
          zIndex: 2,
        }}
      >
        {options.map((option, index) => {
          return (
            <div className="p-xs cursor-hand row" onClick={()=>{onOptionSelect(index);setShowList(!showList);}}>
              <DKCheckMark
                isSelected={option.selected}
                
              />
              <DKLabel className="pl-s" text={option.name} />
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div
      id={props.id}
      className={`multi-select-list parent-width fw-m ${props.className}`}
      style={props.style}
    >
      <DKButton
        id={props.id}
        className={`border-m bg-white shadow-s ${
          options.find((i) => i.selected) ? "border-blue text-blue" : ""
        }`}
        icon={showList ? DKIcons.ic_arrow_up2 : DKIcons.ic_arrow_down2}
        isReverse={true}
        onClick={() => setShowList(!showList)}
        title={
          options.find((i) => i.selected)
            ? options.find((i) => i.selected).name
            : props.name
        }
      />
      {showList && getOptionList()}
    </div>
  );
};
export default ContextMenu;
